import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  // FaInstagram,
  FaTiktok,
  FaTwitter,
  FaYoutube,
  // FaYoutube,
} from "react-icons/fa6";
import rdaLogo from "../../asset/rda-white-logo.png";
import { GoArrowUpRight } from "react-icons/go";
import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";

const Footer = () => {
  return (
    <div className=" bg-[#00643b] flex flex-col ">
      <div className="px-[5%] pt-16 flex lg:flex-row flex-col pb-8 gap-16">
        <div className="flex-1 flex flex-col gap-4">
          <img src={rdaLogo} className="md:w-28 w-24" alt="" />
          {/* <NavLink
            to="mailto:info@rda.gop.pk"
            target="_blank"
            className="flex justify-between items-center text-white"
          >
            <span>RDA’s E-Mail Address</span>{" "}
            <GoArrowUpRight className="size-6" />
          </NavLink> */}
          {/* <hr /> */}
          <div className="text-white">
            Rawalpindi (راولپنڈی) is a major city in the Pothohar region of
            Punjab, Pakistan, located adjacent to the national capital,
            Islamabad. The Rawalpindi Development Authority (RDA) is actively
            working toward the development and betterment of this culturally
            rich and historic city.
          </div>
          {/* <div className="flex items-center gap-8 text-white">
            <NavLink
              to={"https://web.facebook.com/RawalpindiDevelopmentAuthority"}
              target="_blank"
            >
              Facebook
            </NavLink>
            <NavLink to={""} target="_blank">
              Instagram
            </NavLink>
            <NavLink
              to={
                "https://www.linkedin.com/company/rdarwp/?originalSubdomain=pk"
              }
              target="_blank"
            >
              Linkedin
            </NavLink>
          </div> */}
        </div>
        <div className="flex-1 flex sm:flex-row flex-col gap-5  justify-between items-start text-white">
          <div className="flex-1 flex flex-col gap-4">
            <h1 className="text-[1.2rem] font-medium">Useful Links</h1>
            <div className="flex flex-col gap-4">
              <NavLink to={"/tenders"}>Tenders</NavLink>
              <NavLink to={"/project-2"}>Project</NavLink>
              <NavLink to={"/press-release"}>Press Release</NavLink>
              <NavLink to={"/media"}>Media</NavLink>
              <NavLink to={"/careers"}>Careers</NavLink>
            </div>
          </div>
          <div className="flex-1">
            <div className="flex-1 flex flex-col gap-4">
              <h1 className="text-[1.2rem] font-medium">Contact Information</h1>
              <ul className="flex flex-col gap-4 list-disc pl-5">
                <li>
                  <NavLink
                    to="https://www.google.com/maps?q=RDA+Headquarters+Murree+Road+Near+Liaqat+Bagh+Rawalpindi+Pakistan"
                    target="_blank"
                  >
                    RDA Headquarters, Murree Road, Near Liaqat Bagh, Rawalpindi,
                    Pakistan
                  </NavLink>
                </li>
                <li>
                  <NavLink to={"tel:051555549092"} target="_blank">
                    Tel.: 051-5555490-92
                  </NavLink>
                </li>
                <li>
                  <NavLink to="mailto:info@rda.gop.pk" target="_blank">
                    Mail : info@rda.gop.pk
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className=" w-full text-white px-[5%] flex md:flex-row flex-col-reverse justify-between md:items-center items-start md:gap-0 gap-3 py-4">
        <span className="flex-1 text-left ">
          © {new Date().getFullYear()} All rights reserved
        </span>
        <span className="flex-1 flex items-center justify-center gap-6">
          <span>Terms</span>
          <span>Privacy</span>
          <span>Cookies</span>
        </span>
        <span className="flex-1 flex items-center gap-6 justify-end">
          <NavLink
            to={
              "https://www.facebook.com/RawalpindiDevelopmentAuthority?_rdc=1&_rdr#"
            }
            target="_blank"
            className="bg-black p-2 rounded-full"
          >
            <FaFacebookF className="size-5" />
          </NavLink>
          <NavLink
            to={"https://x.com/RdaRawalpindi"}
            target="_blank"
            className="bg-black p-2 rounded-full"
          >
            <FaTwitter className="size-5" />
          </NavLink>
          {/* <NavLink
            to={"https://www.instagram.com/"}
            target="_blank"
            className="bg-black p-2 rounded-full"
          >
            <FaInstagram className="size-5" />
          </NavLink> */}
          <NavLink
            to={
              "https://youtube.com/@rawalpindidevelopmentauthority?si=jkvsNU3MuJO2oRNQ"
            }
            target="_blank"
            className="bg-black p-2 rounded-full"
          >
            <FaYoutube className="size-5" />
          </NavLink>
        </span>
      </div>
      {/* <div className=" w-full flex items-center justify-center gap-2 lg:text-xl md:text-lg sm:text-base text-sm bg-[#064D30] text-[#FFFFFF99] py-5 capitalize">
        Designed & Developed by
        <NavLink to={"https://easterntechno.com/"} target="_blank">
          <ReactSVG
            src="/icon/eastern tech.svg"
            className={`lg:w-44 md:w-40 sm:w-36 w-32`}
          />
        </NavLink>
      </div> */}
    </div>
  );
};

export default Footer;
